import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useSnackbar } from 'ui-components';
import { SavedListsModal } from '~/components/SavedListsModal';
import { SavedListMapState } from '~/components/SavedListsModal/SavedListsModal.types';
import { queryClient } from '~/config/reactQueryConfig';
import { routes } from '~/core/router';
import {
  AGENCY_SAVED_LISTS,
  SAVED_LISTS,
  SAVED_LIST_CREATORS,
  SAVED_LIST_CREATORS_SEARCH,
} from '~/queries/keys';
import { useSavedListsStore } from '~/screens/MyAgency/store/useSavedListsStore';
import { ICreator } from '~/types';

interface Props {
  creator?: ICreator;
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const AddingToAnExistingListModal: React.FC<Props> = ({
  creator,
  isOpen,
  onClose,
}) => {
  const { creators, clearStore } = useSavedListsStore();
  const router = useRouter();
  const snackbar = useSnackbar();

  const creatorList = useMemo(() => {
    if (creators.length) {
      return creators;
    }

    if (creator) {
      return [creator];
    }

    return [];
  }, [creator, creators]);

  const handleSuccess = (state: SavedListMapState) => {
    const listIds = Object.keys(state);

    clearStore();

    queryClient.invalidateQueries([AGENCY_SAVED_LISTS]);
    queryClient.invalidateQueries([SAVED_LIST_CREATORS_SEARCH]);
    queryClient.invalidateQueries([SAVED_LIST_CREATORS]);
    queryClient.invalidateQueries([SAVED_LISTS]);

    if (listIds.length === 1) {
      return snackbar.success({
        action: {
          label: 'View',
          onClick: () => router.push(routes.savedListDetail(listIds[0])),
        },
        description: 'Talent successfully added to list',
        isCloseable: true,
      });
    }

    snackbar.success({
      description: 'Talent successfully added to lists',
      isCloseable: true,
    });
  };

  return (
    <SavedListsModal
      creators={creatorList}
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={handleSuccess}
    />
  );
};
